import getAxiosInstance from "../../../common/mhiAxios";
import { UpdateVideoInfo } from "../../models/video";

export default {
    // 動画出力情報更新
    updateVideoInfo(updateVideoInfo: UpdateVideoInfo): Promise<any> {
        return getAxiosInstance()
            .post("/api/updateVideoInfo", {
                ...updateVideoInfo
            })
            .then(({ data }) => data)
            .catch((error) => {
                return error;
            });
    },
};
